import {
  LinearProgress as MuiLinearProgress,
  LinearProgressProps as MuiLinearProgressProps,
} from '@mui/material';

export const LinearProgress = MuiLinearProgress;
export type LinearProgressProps = MuiLinearProgressProps;
